import React from 'react';
import { useLocation } from 'react-router-dom';
import appConfig from '../appConfig';
const availableApps = appConfig.clientApps;
const useAppStatus = () => {
    const location = useLocation();

	const activeApp = React.useMemo(() => {
		const activeLocationApp = availableApps.find((app) => location.pathname.startsWith(app.link));

		return activeLocationApp || availableApps[0];
	}, [location.pathname]);
    return {
        activeApp
    }
}
export default useAppStatus;